import { gsap } from 'gsap'
import { IsTouchDevice } from './Ua'

export class hoverGallery {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('.js-gallery_pic') === null) return
      let galleryList = Array.prototype.slice.call(document.querySelectorAll('.js-gallery_pic'), 0)
      const body = document.querySelector('body')
      const stalker = document.createElement('div')
      const isTouchDevice = IsTouchDevice()
      const STALKER_SIZE = 15

      const init = () => {
        const self = this
        stalker.id = 'js-pointer'
        stalker.className = 'c-gallery_pointer'
        stalker.innerHTML = '<div class="c-gallery_pointer__fukidashi"></div>'
        body.appendChild(stalker)
        body.addEventListener('mousemove', (e) => {
          gsap.to(stalker, 0.4, {
            x: e.clientX - STALKER_SIZE / 2,
            y: e.clientY - STALKER_SIZE / 2,
          })
        })

        for (let i = 0; i < galleryList.length; i++) {
          galleryList[i].addEventListener('mouseenter', (e) => {
            let caption = e.target.getAttribute('data-caption')
            stalker.querySelector('.c-gallery_pointer__fukidashi').textContent = caption
            stalker.classList.add('is-act')
            e.target.classList.add('is-act')
          })
          galleryList[i].addEventListener('mouseleave', (e) => {
            stalker.classList.remove('is-act')
            e.target.classList.remove('is-act')
            // stalker.querySelector('.c-gallery_pointer__fukidashi').textContent = ''
          })
        }
      }

      if (!isTouchDevice) {
        init()
      }
    })
  }
}
